import { setupEntryPoint } from './setupEntryPoint';
import App from '@/layouts/website/MainLayout.vue';
import router from '@/routers/website';
import '@/assets/css/style.scss';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fortawesome/fontawesome-free/js/all.min.js';

setupEntryPoint(App, router);
